// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8974) return "8974.99d60c4ec9fbed20e732.app-chunk.min.js?v=1756385561476";
	if (chunkId === 3470) return "3470.2be672ee49d40a8592c9.app-chunk.min.js?v=1756385561476";
	if (chunkId === 3602) return "notification.bbcb2158b20078e3b320.app-chunk.min.js?v=1756385561476";
	if (chunkId === 2917) return "sticky-cart-new-4-0-13.c68150810c98bf6405ee.app-chunk.min.js?v=1756385561476";
	if (chunkId === 8075) return "wishlist-new-4-0-3.34578b952595e09e48e3.app-chunk.min.js?v=1756385561476";
	if (chunkId === 4026) return "new-customer-pop.a3a78df6092d9662db86.app-chunk.min.js?v=1756385561476";
	if (chunkId === 9964) return "membership-packet.05d6b3a492692dd4b983.app-chunk.min.js?v=1756385561476";
	// return url for filenames based on template
	return undefined;
};